import { render, staticRenderFns } from "./edittask.vue?vue&type=template&id=6b7a4a9d&scoped=true"
import script from "./edittask.vue?vue&type=script&lang=js"
export * from "./edittask.vue?vue&type=script&lang=js"
import style0 from "./edittask.vue?vue&type=style&index=0&id=6b7a4a9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7a4a9d",
  null
  
)

export default component.exports